import React from 'react';
import { Card, Typography, Box } from '@mui/material';

const StatsSmallCard = ({ title, value, color, sx }) => (
  <Card sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, height: '100%', ...sx }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        p: 1,
        borderRadius: '3%',
        color: '#fff',
        bgcolor: theme => theme.palette[color]?.main || theme.palette.primary.main,
      }}
    >
      <Typography variant="button" color="inherit">
        {title}
      </Typography>
      <Typography variant="h6" color="inherit">{value}</Typography>
    </Box>
  </Card>
);

export default StatsSmallCard;
